const STATUS_INITIAL_STATE = { description: 'All', id: '' }

const DMS_ORDER_STATUS_OPTIONS = [
  { description: 'All', id: '' },
  { description: 'Hold', id: 'Hold' },
  { description: 'Partial Hold', id: 'Partial Hold' },
  { description: 'In Progress', id: 'In Progress' },
  { description: 'Shipped', id: 'Shipped' },
]

const WMS_ORDER_AND_SHIPMENT_STATUS_OPTIONS = [
  { description: 'All', id: '' },
  { description: 'Ready to Plan', id: 'Ready to Plan' },
  { description: 'Planned', id: 'Planned' },
  { description: 'Picking in Progress', id: 'Picking in Progress' },
  { description: 'Picked', id: 'Picked' },
  { description: 'Packed', id: 'Packed' },
  { description: 'Released', id: 'Released' },
  { description: 'Unfilled', id: 'Unfilled' },
  { description: 'Shipped', id: 'Shipped' },
]

const INVOICE_PAYMENT_STATUS_OPTIONS = [
  { description: 'All', id: '' },
  { description: 'Paid', id: 'Paid' },
  { description: 'Partially Paid', id: 'Partially Paid' },
  { description: 'Unpaid', id: 'Unpaid' },
]

const USER_MANAGEMENT_STATUS_OPTIONS = [
  { description: 'All', id: '' },
  { description: 'Active', id: 'Active' },
  { description: 'Invited', id: 'Invited' },
  { description: 'Deactivated', id: 'Deactivated' },
]

export {
  STATUS_INITIAL_STATE,
  DMS_ORDER_STATUS_OPTIONS,
  WMS_ORDER_AND_SHIPMENT_STATUS_OPTIONS,
  INVOICE_PAYMENT_STATUS_OPTIONS,
  USER_MANAGEMENT_STATUS_OPTIONS,
}
